(() => {
  const initialise = (root) => {
    if (root.dataset.initialised) return;
    root.dataset.initialised = 'true';
    const variants = JSON.parse(root.querySelector('[data-glow-variants]').textContent);
    const messages = JSON.parse(root.querySelector('[data-glow-messages]').textContent);
    const form = root.querySelector('.gs-form');
    const input = root.querySelector('[data-name-input]');
    const error = root.querySelector('[data-name-error]');
    const add = root.querySelector('[data-add-button]');
    const money = (cents) => new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(cents / 100);
    const update = (showErrors = false) => {
      const name = input.value.normalize('NFC').trim();
      const count = Array.from(new Intl.Segmenter('nl', { granularity: 'grapheme' }).segment(name)).filter(({ segment }) => /\S/u.test(segment)).length;
      const size = form.querySelector('[name="glow_size"]:checked').value;
      const baseVariant = variants.find((v) => v.options[0] === size && v.options[1] === '0');
      const variant = variants.find((v) => v.options[0] === size && v.options[1] === String(count));
      let issue = '';
      if (count > 10) issue = messages.long;
      else if (!variant) issue = messages.unavailable;
      else if (!variant.available) issue = messages.sold_out;
      const basePrice = baseVariant ? baseVariant.price : 0;
      root.querySelector('[data-base-price]').textContent = money(basePrice);
      const totalPrice = variant ? variant.price : basePrice;
      root.querySelector('[data-fee-price]').textContent = money(totalPrice - basePrice);
      root.querySelector('[data-total-price]').textContent = money(totalPrice);
      root.querySelector('[data-count-label]').textContent = '(' + count + ')';
      root.querySelector('[data-name-preview]').textContent = name || input.dataset.emptyPreview;
      root.querySelector('[data-letter-count]').value = count;
      root.querySelector('[data-variant-id]').value = variant ? variant.id : '';
      error.textContent = issue;
      error.hidden = !issue || (!showErrors && !input.value);
      input.setCustomValidity(issue);
      input.setAttribute('aria-invalid', String(Boolean(issue && (showErrors || input.value))));
      add.disabled = Boolean(issue);
      return !issue;
    };
    input.addEventListener('input', () => update());
    input.addEventListener('blur', () => update(true));
    form.querySelectorAll('[name="glow_size"]').forEach((radio) => radio.addEventListener('change', () => update()));
    form.addEventListener('submit', (event) => {
      if (!update(true)) {
        event.preventDefault();
        input.reportValidity();
        return;
      }
      input.value = input.value.normalize('NFC').trim();
    });
    root.querySelectorAll('.gs-thumb').forEach((button) => button.addEventListener('click', () => {
      const image = root.querySelector('.gs-featured');
      image.removeAttribute('srcset');
      image.src = button.dataset.imageUrl;
      image.alt = button.dataset.imageAlt || '';
      root.querySelectorAll('.gs-thumb').forEach((b) => b.setAttribute('aria-pressed', String(b === button)));
    }));
    update();
  };
  const initialiseAll = () => document.querySelectorAll('[data-glow-product]').forEach(initialise);
  initialiseAll();
  document.addEventListener('shopify:section:load', initialiseAll);
})();
